import { __makeTemplateObject } from "tslib";
import { css, getParsePaletteColor, } from '../../../../foundation';
export var CircularProgressStyle = function (props) {
    var color = props.color;
    var currColor = getParsePaletteColor(color);
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    color: ", ";\n  "], ["\n    color: ", ";\n  "])), currColor);
};
var templateObject_1;
